export default {
  guests_pay: 'Los clientes pagan {{amount}} al finalizar la compra (tipo de cambio más reciente).',
  missing_rate: 'Aún no hay tipo de cambio para {{currency}}, así que los clientes pagan {{amount}} sin convertir.',
};
